import React from 'react';
import { BaseCard, BaseCardBody } from '@unite-us/ui';
import './NoProvidedServiceCard.scss';

const NoProvidedServiceCard = () => (
  <BaseCard>
    <BaseCardBody withPadding>
      <div className="no-fee-schedule-services-provided">No Contracted Services</div>
    </BaseCardBody>
  </BaseCard>
);

export default NoProvidedServiceCard;
